<dialog-gala (clickClose)="askHideModal()">
  <span gala-dialog-titre>{{lgTrad.AFFGRP}}</span>
  <form [formGroup]="formData" autocomplete="off">
    <div class="row">
      <div class="col-md-12">
        <select-gala formControlName="RFGROUPE" [options]="listeGroupes" bindLabel="GROUPE" container="#groupes"
          [label]="lgTrad.GROUPES" [disabled]="!droitsAccess.write || isSuppression" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          @if (!isSuppression) {
            <date-gala [label]="lgTrad.DEBUT" [placeholder]="lgTrad.BEGINNINGDATE"
              formControlName="DDEBUT" />
          }
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          @if (isSuppression) {
            <date-gala [label]="lgTrad.FIN" [placeholder]="lgTrad.ENDDATE"
              formControlName="DFIN" />
          }
        </div>
      </div>
    </form>
    <div gala-dialog-actions>
      @if (droitsAccess.write) {
        <button mat-stroked-button color="primary" (click)="enregistrerGroupe()"
        >{{lgTrad.ENR}}</button>
      }
      <button mat-stroked-button color="accent" (click)="askHideModal()">{{lgTrad.RET}}</button>
    </div>
  </dialog-gala>